export default {
  routes: [
    {
      name: 'routes',
      path: '/development/routes',
      component: () => import('./views/TheRoutes.vue')
    },
  ]
}
